import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event.stopPropagation()

    const isOpen = !this.menuTarget.classList.contains("hidden")

    this.closeAll()

    if (!isOpen) {
      this.menuTarget.classList.remove("hidden")
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
  }

  closeAll() {
    document.querySelectorAll("[data-dropdown-target='menu']").forEach((el) => {
      el.classList.add("hidden")
    })
  }

  connect() {
    this.boundClose = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.boundClose)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose)
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}